import React from 'react';
import  './Switcher.css';

const Switcher =  ({ content, onClick, selected, selectedItem, itemsLength }) => {
  return (
      <button
        // selected={selected}
        value={content}
        onClick={onClick}
        className={selected && selectedItem === content ? 'content-selected' : 'content'}>
        {itemsLength === undefined ? content : content+' ('+itemsLength+')'}
      </button>
  )
}

export default Switcher;